import {DisparoAutomaticoModel} from './disparo-automatico.model';

export class DisparoAutomaticoVariavelModel{

  ordem?: number;
  valor?: string;
  isCampoContato = false;
  tipoCampoContato?: string;
  disparoAutomatico?: DisparoAutomaticoModel;
  nomeColuna?: string;
  colunaComplementarId?: number;

}
